import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "quick-topup-title"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "quick-topup-price" }
const _hoisted_6 = {
  key: 0,
  class: "quick-topup-tokens"
}
const _hoisted_7 = {
  key: 0,
  class: "quick-topup-token-divider"
}
const _hoisted_8 = { class: "quick-topup-token" }
const _hoisted_9 = { class: "quick-topup-token-icon" }
const _hoisted_10 = { class: "quick-topup-token-amount" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { WalletPackage, WalletPackageContent } from '@/shared/interfaces/wallet';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickTopUpCard',
  props: {
	quickPackages: { type: Array as () => WalletPackage[], required: true },
	variant: { type: String, default: 'dark' },
	loading: { type: Boolean, default: false },
},
  emits: ['onQuickTopUp'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();

const packages = computed(() => {
	if (!props.quickPackages?.length) return [];

	return props.quickPackages.slice(0, 2).map((pkg) => {
		const contents = pkg.contents.map((content: WalletPackageContent) => ({
			id: content.id,
			amount: content.amount,
			currency: content.currency,
			euroPrice: +content.amount * +content.currency.exchange_rate,
			isEuro: content.currency.name.toUpperCase() === 'EURO',
		}));

		const allEuroContents = contents.every((c) => c.isEuro);
		const showTokens = !allEuroContents;

		return {
			...pkg,
			priceInclFee: +pkg.clientx_price_incl_fee,
			displayContents: contents,
			showTokens,
		};
	});
});

const handleCardClick = (pkg) => {
	emit('onQuickTopUp', pkg);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["quick-topup-wrapper", { 'quick-topup-wrapper--light': __props.variant === 'light' }])
  }, [
    (__props.loading && packages.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "quick-topup-skeleton quick-topup-skeleton--title" }, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["quick-topup-list", { 'quick-topup-list--light': __props.variant === 'light' }])
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
              return _createElementVNode("div", {
                class: "quick-topup-card quick-topup-card--skeleton",
                key: i
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "quick-topup-skeleton quick-topup-skeleton--price" }, null, -1),
                _createElementVNode("div", { class: "quick-topup-skeleton quick-topup-skeleton--tokens" }, null, -1)
              ]))])
            }), 64))
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (packages.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(t)('top_up.quick_topup_title')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["quick-topup-list", { 'quick-topup-list--light': __props.variant === 'light' }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(packages.value, (pkg) => {
              return (_openBlock(), _createElementBlock("div", {
                key: pkg.id,
                class: "quick-topup-card",
                onClick: ($event: any) => (handleCardClick(pkg))
              }, [
                _createElementVNode("span", _hoisted_5, "€" + _toDisplayString(pkg.priceInclFee.toFixed(2)), 1),
                (pkg.showTokens)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pkg.displayContents, (content, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: content.id
                        }, [
                          (index > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "|"))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(content.currency.prefix), 1),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(content.amount), 1)
                          ])
                        ], 64))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_4))
            }), 128))
          ], 2)
        ]))
  ], 2))
}
}

})